import React from 'react';
import './style.css';


function YoutubeFrame() {
    const serachParams = new URLSearchParams(window.location.search);

    const url = `https://www.youtube.com/embed/${serachParams.get("ytid")}?autoplay=1&mute=0&controls=1&fs=0&showinfo=0`;

    console.log('enlace'+url);
    return (
<div class="videoWrapper">
  <iframe width="560" 
  height="349" 
  src={url} 
  frameborder="0" 
  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
  allowfullscreen="true"
  auto></iframe>
</div>
    );
}

export default YoutubeFrame;